export const playerEvents = {
  CLOSE: "PLAYER:CLOSE",
  OPEN: "PLAYER:OPEN",
  PAUSE: "PLAYER:PAUSE",
  PLAY: "PLAYER:PLAY",
  PLAY_DEFAULT_STREAM: "PLAYER:PLAY_DEFAULT_STREAM",
  REQUEST_STATUS: "PLAYER:REQUEST_STATUS",
  SEEK_TO: "PLAYER:SEEK_TO",
  SET: "PLAYER:SET",
  STATUS_CHANGE: "PLAYER:STATUS_CHANGE",
  STOP: "PLAYER:STOP",
  TICK: "PLAYER:TICK",
  TIME_UPDATE: "PLAYER:TIME_UPDATE",
  RENDER: "PLAYER:RENDER"
};

export const playableItemEvents = {
  STATUS_CHANGE: "ITEM:STATUS_CHANGE"
};

export const mastheadPlayerEvents = {
  WIGGLE: "MASTHEAD_PLAYER:WIGGLE"
};

export const queueEvents = {
  SET_CURRENT: "QUEUE:SET_CURRENT",
  APPEND: "QUEUE:APPEND",
  PREPEND: "QUEUE:PREPEND",
  RESOLVE: "QUEUE:RESOLVE"
};
